var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("date-picker", {
    ref: "datePicker",
    staticClass: "datePicker-block theme01",
    attrs: {
      "disabled-date": _vm.disabledDate,
      lang: _vm.lang,
      "value-type": "date",
      inline: true,
    },
    model: {
      value: _vm.value2,
      callback: function ($$v) {
        _vm.value2 = $$v
      },
      expression: "value2",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }